export default {
    // 是否正在启动
    isBooting(state, getters) {
        return getters['startup/isIdle'] || getters['startup/isLoading'];
    },
    // 是否已经成功加载完成
    isDone(state, getters) {
        return getters['startup/isComplete'];
    },
    // 是否正在提交
    isSubmitting(state) {
        return state.isSubmitting;
    },
    pageList(state) {
        if (!state.bizInfo || !Array.isArray(state.bizInfo.pages)) {
            return [];
        }

        return state.bizInfo.pages;
    },
    bizConfig(state) {
        return state.bizInfo.config || {};
    },
    pageNames(state, getters) {
        return getters.pageList.map(page => page.pageKey);
    },
    headPageKey(state, getters) {
        if (0 === getters.pageList.length) {
            return null;
        }

        return getters.pageNames[0];
    },
    nextPageKey(state, getters) {
        const { errorData = [] } = state;
        const defaultPageKey = state.nextPageKey || getters.headPageKey;
        if (state.gray.fieldReview && state.status === 3) {
            return errorData.length !== 0
                ? errorData[0].pageKey
                : defaultPageKey;
        }
        return defaultPageKey;
    },
    nextPageIndex(state, getters) {
        if (0 === getters.pageList.length) {
            return -1;
        }
        const lastIndex = getters.pageNames.length - 1;
        return state.gray.fieldReview && state.status === 3
            ? getters.pageNames.indexOf(getters.pageList[lastIndex].pageKey)
            : getters.pageNames.indexOf(getters.nextPageKey);
    },
    currentPageIndex(state, getters) {
        if (0 === getters.pageNames.length) {
            return -1;
        }
        return getters.pageNames.indexOf(state.routerPageKey);
    },
    currentPageTitle(state, getters) {
        if (-1 !== getters.currentPageIndex ) {
            return getters.pageList[getters.currentPageIndex].title || state.bizInfo.name;
        }
        return state.bizInfo && state.bizInfo.name || '信息收集';
    },
    currentPageConfig(state, getters) {
        if (-1 === getters.currentPageIndex) {
            return null;
        }
        const pageData = state.pageInfo[state.routerPageKey];
        let data = null;
        try {
            const jsonString = pageData && pageData.config;
            data = jsonString ? JSON.parse(jsonString) : null;
        } catch (error) {
            console.log(error);
        }
        return data;
    },
    currentPageFormConfig(state, getters) {
        if (!getters.currentPageConfig) {
            return null;
        }
        return getters.currentPageConfig.config;
    },
    currentPageExtraConfig(state, getters) {
        if (!getters.currentPageConfig) {
            return null;
        }
        return getters.currentPageConfig.extraConfig;
    },
    currentDetail(state) {
        if (!state.userData) {
            return null;
        }
        return state.userData[state.routerPageKey] || null;
    },

    currentPageErrorData(state) {
        if (!state.errorData) {
            return null;
        }
        const curErrorItem = state.errorData.find(v => v.pageKey === state.routerPageKey);
        return curErrorItem ? curErrorItem.markList : null;
    },
    currentRejectPages(state) {
        if (!state.errorData) {
            return null;
        }
        const rejectArr = state.errorData.flatMap(v => [v.pageKey]);
        return rejectArr || [];
    },
    steps(state, getters) {
        const currentPageIndex = Math.max(0, getters.currentPageIndex);
        return getters.pageList.map((page, index) => {
            return {
                title: page.label,
                pageKey: page.pageKey,
                current: currentPageIndex === index,
            };
        });
    },
};
